const shell = {
  projectSyncError: '企業プロジェクトを読み込めませんでした。接続を確認して、もう一度お試しください。',
  retry: '再試行',
  projectSwitcher: 'プロジェクト切替',
  switchWorkspace: '企業スペースを切り替え',
  home: 'Navigator ホーム',
  project: 'プロジェクト',
  currentProject: '現在のプロジェクト',
  newProject: '新規プロジェクト',
  navigation: 'メインナビゲーション',
  nav: {
    memory: '記憶',
    diagnosis: '診断',
    action: 'アクション',
    presence: '拠点',
    results: '成果',
  },
  appearance: '外観',
  themeButtonLabel: '外観 · {theme}',
  settings: '設定',
  settingsIntro: '表示、企業スペース、プロジェクトの設定を管理します。',
  personal: '個人',
  workspace: '企業スペース',
  projectSettings: 'プロジェクト',
  interfaceLanguage: '表示言語',
  interfaceLanguageHint: 'Navigator の操作画面だけを切り替えます。企業情報と証拠の原文は変更しません。',
  followSystem: 'システムに合わせる',
  theme: 'テーマ',
  themeSystem: 'システム',
  themeLight: 'ライト',
  themeDark: 'ダーク',
  close: '閉じる',
  vaultConnected: 'プロジェクト空間の準備完了',
  workspaceSettingsIntro: 'この企業で共有するスペース設定を管理します。',
  membersEyebrow: '企業スペースのアクセス管理',
  membersTitle: 'メンバーと権限',
  membersIntro: 'この企業スペースに入れる勤務先メールと、各メンバーが行える作業を管理します。',
  membersScope: '権限は企業スペース内のすべてのプロジェクトに適用されます。',
  activeMembers: '名の有効メンバー',
  memberRoles: { tenant_admin: '企業管理者', operator: '運用担当者', member: 'メンバー' },
  memberRoleShort: {
    tenant_admin: 'メンバー、設定、すべての運用を管理します。',
    operator: 'リードの確認、担当者の割り当て、フォローを記録します。',
    member: '企業プロジェクトを利用し、割り当てられた作業を担当します。',
  },
  memberRoleDetail: {
    tenant_admin: 'メンバーと設定を管理し、運用画面に入り、他のメンバーへリードを割り当てられます。',
    operator: '運用画面でリードを確認し、有効なメンバーへ割り当てられます。',
    member: '企業プロジェクトを利用し、自分の担当作業を処理できます。メンバー管理はできません。',
  },
  memberStatuses: { active: '有効', revoked: '停止済み' },
  memberList: '企業メンバー',
  memberFilter: 'メンバーの絞り込み',
  addMember: 'メンバーを追加',
  manageMember: '管理',
  currentAccount: '現在のアカウント',
  noMembers: 'この状態のメンバーはいません。',
  membersLoading: '企業メンバーを読み込んでいます…',
  membersLoadFailed: '企業メンバーを読み込めませんでした。',
  memberBoundaryTitle: 'V1 の権限範囲：',
  memberBoundaryBody: '企業スペース単位のアクセスのみを管理します。部門・プロジェクト単位の権限は含みません。停止すると既存セッションも直ちに無効になります。',
  memberPermissionTitle: '企業管理者だけがメンバーを管理できます。',
  memberPermissionBody: '現在のアクセス権限は変わりません。',
  addMemberTitle: '企業メンバーを追加',
  addMemberIntro: '勤務先メールを現在の企業スペースに追加します。',
  editMemberTitle: 'メンバーを管理',
  editMemberIntro: '役割の変更は保存後すぐに反映されます。',
  workEmail: '勤務先メール',
  memberEmailHint: '追加後、このメールで安全なワンタイムログインリンクを申請できます。',
  accessRole: 'アクセス権限',
  memberLastAdminTitle: '最後の管理者は降格・停止できません。',
  memberLastAdminBody: '先に別の企業管理者を追加してください。',
  memberSelfGuard: '現在の管理者は自分のアクセス権限を変更できません。',
  deactivateMember: 'アクセスを停止',
  restoreMember: 'アクセスを復元',
  saveMember: '変更を保存',
  savingMember: '保存中…',
  cancel: 'キャンセル',
  memberAdded: 'メンバーを追加しました。',
  memberSaved: 'メンバー権限を更新しました。',
  memberRevoked: 'メンバーのアクセスを停止しました。',
  memberRestored: 'メンバーのアクセスを復元しました。',
  memberExists: 'このメールはすでに企業スペースにあります。',
  memberSaveFailed: 'メンバーの変更を保存できませんでした。',
  projectSettingsIntro: '現在のプロジェクトだけに適用する設定を管理します。',
  defaultOutputLanguage: '既定の作業・レポート言語',
  defaultOutputLanguageHint: '診断レポート、戦略、その他のAI呼び出しに具体的な output_language として送信します。表示言語は変更しません。',
  targetContentLanguages: '対象コンテンツ言語',
  targetContentLanguagesHint: '市場向け制作言語を1つ以上選択します。個別タスクではプロジェクト既定値を上書きできます。',
  saveLanguageSettings: '言語設定を保存',
  savingLanguageSettings: '保存中…',
  languageSettingsSaved: '保存しました',
  languageSettingsFailed: '保存できませんでした。本番設定は以前の値のままです。',
  leadSlaTenantTitle: '企業リード応答ルール',
  leadSlaTenantHint: '企業内プロジェクトで使う既定のリード応答期限を設定します。プロジェクト側で継承、上書き、無効化できます。',
  leadSlaProjectTitle: 'プロジェクトのリード応答ルール',
  leadSlaProjectHint: '企業ルールを継承するか、独自ルールを使うか、今後の計時を無効にするかを選びます。',
  leadSlaLoading: '現在の応答ルールを読み込んでいます…',
  leadSlaEffective: '現在有効',
  leadSlaEnabled: '有効',
  leadSlaDisabled: '無効',
  leadSlaEffectiveSource: '参照元：{source} · ルール revision {revision}',
  leadSlaSourceTenant: '企業ルール',
  leadSlaSourceProject: 'プロジェクトルール',
  leadSlaSourceNone: 'ルール未設定',
  leadSlaMode: 'この階層',
  leadSlaModes: { policy: '独自ルールを使用', disabled: '無効', inherit: '企業ルールを継承' },
  leadSlaClockMode: '計時方法',
  leadSlaClockElapsed: '連続時間',
  leadSlaClockBusiness: '営業時間のみ',
  leadSlaTimezone: 'タイムゾーン',
  leadSlaFirstResponse: '初回応答（分）',
  leadSlaFollowup: 'フォローアップ（分）',
  leadSlaWarning: '事前通知（分）',
  leadSlaBusinessDays: '営業日',
  leadSlaWeekdays: { 0: '月', 1: '火', 2: '水', 3: '木', 4: '金', 5: '土', 6: '日' },
  leadSlaBusinessStart: '開始時刻',
  leadSlaBusinessEnd: '終了時刻',
  leadSlaAdminOnly: 'この設定を変更できるのは企業管理者だけです。',
  leadSlaValidation: 'すべての項目を入力してください。通知時間は両方の応答期限より短くする必要があります。',
  leadSlaSave: '応答ルールを保存',
  leadSlaSaving: '保存中…',
  leadSlaSaved: '応答ルールを保存しました',
  leadSlaSaveFailed: '保存できませんでした。現在のルールを再読込してからお試しください。',
  leadSlaUnavailable: '現在の応答ルールを読み込めませんでした。',
  leadSlaNoScope: '現在の企業またはプロジェクトはまだ利用できません。',
  leadSlaClockBoundary: '設定変更で進行中の計時は書き換わりません。現在の段階は開始時のルールで完了し、無効化後は次の段階を開始せず、継承後の次段階ではその時点で有効な企業ルールを使います。',
  airlockAppearance: 'WebサイトのAirlock外観',
  airlockAppearanceHint: '顧客サイトに設置する受付モジュールの外観を設定します。Navigator本体には影響しません。',
  airlockLoading: '現在のWebサイト外観を読み込んでいます…',
  airlockPreviewEyebrow: 'Webサイト受付',
  airlockPreviewTitle: 'どのようにお手伝いできますか？',
  airlockPreviewBody: '保存前に、許可された色、角丸、フォントを確認できます。',
  airlockPreviewAction: '会話を始める',
  airlockColorScheme: 'ライト・ダーク表示',
  airlockScheme: { auto: '訪問者の端末に合わせる', light: '常にライト', dark: '常にダーク' },
  airlockColors: 'ブランドカラー',
  airlockColorsHint: '「サイト標準」のままにすると、安全な既定値が使われます。',
  airlockAccent: '主な操作',
  airlockOnAccent: '主な操作の文字',
  airlockSurface: 'メイン背景',
  airlockSurfaceAlt: 'サブ背景',
  airlockText: 'メイン文字',
  airlockMuted: '補助文字',
  airlockLine: '境界線と区切り',
  airlockInherit: 'サイト標準',
  airlockUseDefault: '標準を使用',
  airlockCornerRadius: '角丸',
  airlockFont: 'フォント',
  airlockFontHost: 'Webサイトに合わせる',
  airlockFontSans: 'Navigator Sans',
  airlockFontSerif: 'Navigator Serif',
  airlockSave: 'Airlock外観を保存',
  airlockSaving: '保存中…',
  airlockSaved: 'Webサイト外観を保存しました',
  airlockSaveFailed: '保存できませんでした。現在の設定を再読込してからお試しください。',
  airlockUnavailable: 'このプロジェクトではWebサイト外観をまだ設定できません。',
  airlockRetry: '再試行',
  airlockBoundary: '入力できるのは許可された色、角丸、フォント、表示モードだけです。CSS、URL、スクリプトは入力できません。',
  subscription: '契約と請求',
  billingLoading: '契約状況を読み込んでいます…',
  billingUnavailable: '現在、契約・請求サービスを利用できません。',
  billingEyebrow: 'Navigator billing · Stripe Sandbox',
  billingTitle: 'プランと契約',
  billingIntro: 'この企業スペースの継続運用容量を選択します。Navigator の能力は進化し続け、プランは固定機能ではなく利用容量を定義します。',
  billingSandbox: 'テストモード · 本請求なし',
  billingEnterprise: '請求対象の企業スペース',
  billingCurrent: '現在の契約',
  billingStatus: {
    AWAITING_PAYMENT: '支払い待ち',
    ACTIVE: '有効',
    CANCEL_AT_PERIOD_END: '今期末で終了',
    PAST_DUE: '支払い遅延',
    EXPIRED: '期限切れ',
    REFUNDED: '返金済み',
  },
  billingPeriodEnd: '現在の期間は {date} まで',
  billingNoSubscription: 'この企業スペースには有効な契約がありません。',
  billingInterval: '請求間隔',
  billingMonthly: '月払い',
  billingAnnual: '年払い',
  billingAnnualPromo: '10か月分で12か月利用',
  billingPlan: {
    launch: '継続的な成長循環を始める小規模チーム向け。',
    growth: '市場と業務サイクルを拡大する成長チーム向け。',
    scale: 'より大きな規模と複雑な連携を運用する組織向け。',
    enterprise: '価格、導入範囲、サービス条件を契約で個別に定めます。',
  },
  billingMonthUnit: '月',
  billingYearUnit: '年',
  billingStartCheckout: '安全な決済へ進む',
  billingRedirecting: '決済画面を開いています…',
  billingCustom: '個別見積り',
  billingContractOnly: 'お問い合わせ',
  billingAdminOnly: '企業スペース管理者だけが契約を開始できます。',
  billingExistingGuard: 'このスペースには契約があります。Sandbox 段階ではプラン変更と解約を利用できません。',
  billingCheckoutFailed: '決済画面を開けませんでした。契約状況は変更されていません。',
  billingBoundary: 'テスト環境専用です。企業IDはログイン済みの Navigator セッション、価格は固定された Sandbox 価格表から取得し、ブラウザから変更できません。',
  billingUsageEyebrow: '容量オブザベーション',
  billingUsageTitle: '今期のビジネス使用量',
  billingUsageObserveOnly: '現在は研究用の観測値のみです。参照値に達してもサービス停止、ダウングレード、自動課金は行いません。',
  billingUsageCounter: {
    completed_cycle: '完了サイクル',
    standard_artifact: '標準成果物',
    localization_version: 'ローカライズ版',
    publication_position: '新規公開先',
    airlock_conversation: 'Airlock AI 会話',
  },
  billingUsageBreakdown: '使用済み {used} · 進行中 {inFlight} · 待機 {queued}',
  billingUsageNotConnected: 'データ未接続',
  billingUsageNotConnectedDetail: '信頼できる業務ソースへの接続後に、実際の使用量が表示されます。',
  billingUsageBoundary: 'スラッシュ後の数値は Sandbox の観測基準であり、顧客契約の保証枠ではありません。',
  outputLanguageBoundary: '言語の選択は Navigator が所有します。Foundry は呼び出しごとに具体的な BCP-47 output_language を受け取り、グローバル既定値を定義しません。',
  settingsBoundary: 'ここには顧客向けアプリ設定と企業アクセス権限を置きます。内部運用とシステム制御は別の管理画面で扱います。',
  settingsDeferred: '設定入口と所有権の境界は準備済みです。詳細項目は本番契約の承認後に接続します。',
  signedInAs: 'ログイン中のメール',
  signOut: 'ログアウト',
  signingOut: 'ログアウト中…',
  signOutFailed: 'ログアウトできませんでした。接続を確認して再試行してください。',
  surfacePendingEyebrow: 'グローバルシェル · 画面接続',
  surfacePendingTitle: '{route}画面を接続中',
  surfacePendingBody: 'ナビゲーション、言語、設定の境界は準備済みです。この画面の本番内容は対応するページ工程で接続します。',
} as const

export default shell
